import { useEffect } from "react";
import {
  ClientResponse,
  AgencyResponse,
  LocationResponse,
  TerminalResponse,
  ReduxFreeformActions,
} from "../types";

const useSetFormFieldsState = (
  actions: ReduxFreeformActions,
  apiData?: ClientResponse | AgencyResponse | LocationResponse | TerminalResponse
): void => {
  useEffect(() => {
    /**
     * Set form state based on data returned from the Cashiering API.
     */
    if (apiData && actions.fields) {
      Object.entries(apiData.data).forEach(([key, value]) => {
        if (value && typeof value === "object" && !Array.isArray(value)) {
          /**
           * We need this to map the api data to redux freeform fields
           * if the endpoint contains nested objects
           */
          for (const fieldName in value) {
            if (actions.fields[fieldName] && value[fieldName]) {
              actions.fields[fieldName].set(String(value[fieldName]));
            }
          }
        } else {
          if (actions.fields[key]) {
            // Ternary protects fields from being set to a stringified "null" or "undefined"
            actions.fields[key].set(
              String(typeof value === "boolean" || value ? apiData.data[key] : "")
            );
          }
        }
      });
    }
  }, [actions.fields, apiData]);
};

export default useSetFormFieldsState;
